import angular from 'angular'
import angularOAuth2 from 'angular-oauth2'
import uiRouter from 'angular-ui-router'
import ngSanitize from 'angular-sanitize'
import myBookingApi from '../../../../api/mybooking/mybooking'

import viewComponent from './view.component'

const viewModule = angular.module('view', [
    uiRouter,
    angularOAuth2.name,
    ngSanitize,
    myBookingApi
])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.view', {
                url: '/view',
                views: {
                    'booking@bookings.booking': {
                        template: '<view></view>'
                    }
                }
            })
    })
    .component('view', viewComponent)
    .name

export default viewModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/view/view.js